import notificationSound from '@/assets/sound/notification-sound.mp3'

let audioEnabled = false;
let audioContext: AudioContext | null = null;
let audioBuffer: AudioBuffer | null = null;

// Preload and decode audio
const preloadAudio = async () => {
  try {
    const response = await fetch(notificationSound);
    const arrayBuffer = await response.arrayBuffer();
    
    if (!audioContext) {
      audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
    }
    
    audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
    console.log('Notification sound preloaded successfully');
  } catch (error) {
    console.error('Failed to preload notification sound:', error);
  }
};

// Enable audio on first user interaction
const enableAudio = async () => {
  if (audioEnabled) return;
  
  try {
    if (!audioContext) {
      audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
    }
    
    // Resume audio context if suspended
    if (audioContext.state === 'suspended') {
      await audioContext.resume();
    }
    
    // Preload audio if not already loaded
    if (!audioBuffer) {
      await preloadAudio();
    }
    
    audioEnabled = true;
    console.log('Audio enabled successfully');
    
    // Remove event listeners after first interaction
    document.removeEventListener('click', enableAudio);
    document.removeEventListener('keydown', enableAudio);
    document.removeEventListener('touchstart', enableAudio);
  } catch (error) {
    console.error('Failed to enable audio:', error);
  }
};

// Set up event listeners for user interaction
if (typeof window !== 'undefined') {
  document.addEventListener('click', enableAudio, { once: true });
  document.addEventListener('keydown', enableAudio, { once: true });
  document.addEventListener('touchstart', enableAudio, { once: true });
  
  // Preload audio on page load
  preloadAudio();
}

// Function to play notification sound
export const playNotificationSound = () => {
  if (!audioEnabled) {
    console.warn("Audio playback requires user interaction first");
    return;
  }
  
  try {
    if (audioContext && audioBuffer) {
      // Use Web Audio API for better performance and reliability
      const source = audioContext.createBufferSource();
      source.buffer = audioBuffer;
      source.connect(audioContext.destination);
      source.start(0);
    } else {
      // Fallback to HTML Audio element
      const audio = new Audio(notificationSound);
      audio.play().catch((error) => {
        console.error("Failed to play the notification sound", error);
        // Reset audio enabled flag on persistent errors
        if (error.name === 'NotAllowedError') {
          audioEnabled = false;
        }
      });
    }
  } catch (error) {
    console.error("Error playing notification sound:", error);
  }
};
